<template>
	<el-drawer
		class="chat-usuarios"
		title="Contactos"
		size="60%"
		:visible.sync="visible"
		:modal-append-to-body="false"
	>

		<ul class="contacts">

			<li
				v-for="item in contacts"
				:key="item.id"
				:class="{ aviso: item.aviso, active: partner.id === item.id }"
				@click="$emit('partner', item)"
			><i class="el-icon-user"></i> {{ item.name }}</li>

		</ul>

	</el-drawer>
</template>

<script>
	export default {
		name: 'ChatUsuarios',
		props: {
			ws: {
				required: true
			},
			showContacts: {
				type: Boolean,
				required: true
			},
			user: {
				type: Object,
				required: true
			},
			partner: {
				required: true,
				type: Object
			}
		},
		data () {
			return {
				contacts: [],
			}
		},
		computed: {

			visible: {
				get () { return this.showContacts },
				set (val) { this.$emit('update:showContacts', val) }
			}

		},
		watch: {

			contacts: {
				deep: true,
				handler (val) { this.$emit('aviso', val.filter(c => c.aviso).length) }
			},

			partner (val) {

				if (!val.id) return

				this.contacts.find(c => val.id === c.id).aviso = false

			}

		},
		created () {

			this.ws.onMsg('msg', this.onMsg)

			this.ws.onMsg('usuarios', this.onUsuarios)

			this.ws.sendMsg('usuarios')

			window.addEventListener('focus', () => {

				if (!this.partner.id) return

				this.contacts.find(c => this.partner.id === c.id).aviso = false

			})

		},
		beforeDestroy () {

			this.ws.delMsg('usuarios', this.onUsuarios)

			this.ws.delMsg('msg', this.onMsg)

		},
		methods: {

			onMsg (msg) {

				if (msg.sender.id === this.user.id) return

				if (this.partner.id && msg.sender.id === this.partner.id && document.hidden === false) return

				new Notification(msg.sender.name, {
					body: msg.msg,
					vibrate: [200, 100, 200]
				})

				const c = this.contacts.find(c => c.id === msg.sender.id)

				if (c) c.aviso = true



			},

			onUsuarios (usuarios) {

				const users = new Set()

				usuarios.filter(u => u.id !== this.user.id).forEach(u => users.add(u.id))

				this.contacts = Array.from(users).map(u => ({
					...usuarios.find(us => us.id === u),
					aviso: false
				}))

			}

		}
	}
</script>
